import { render, staticRenderFns } from "./RetrievePartner.vue?vue&type=template&id=0a4283b6&scoped=true&"
import script from "./RetrievePartner.vue?vue&type=script&lang=js&"
export * from "./RetrievePartner.vue?vue&type=script&lang=js&"
import style0 from "./RetrievePartner.vue?vue&type=style&index=0&id=0a4283b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4283b6",
  null
  
)

export default component.exports